import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  GET_ALL_CONTACTS: createSagaAction('GET_ALL_CONTACTS'),
  GET_CONTACT_LIST: createSagaAction('GET_CONTACT_LIST'),
  CREATE_CONTACT_INDIVIDUAL: createSagaAction('CREATE_CONTACT_INDIVIDUAL'),
  EDIT_CONTACT_INDIVIDUAL: createSagaAction('EDIT_CONTACT_INDIVIDUAL'),
  DELETE_CONTACT_INDIVIDUAL: createSagaAction('DELETE_CONTACT_INDIVIDUAL'),
  ADD_EMAIL: createSagaAction('ADD_EMAIL'),
  EDIT_EMAIL: createSagaAction('EDIT_EMAIL'),
  DELETE_EMAIL: createSagaAction('DELETE_EMAIL'),
  GET_EMAILS: createSagaAction('GET_EMAILS'),
  ADD_PHONE: createSagaAction('ADD_PHONE'),
  EDIT_PHONE: createSagaAction('EDIT_PHONE'),
  DELETE_PHONE: createSagaAction('DELETE_PHONE'),
  GET_PHONES: createSagaAction('GET_PHONES'),
  GET_COMPANY_CONTACTS: createSagaAction('GET_COMPANY_CONTACTS'),
  COMPANY_CREATE_CONTACT: createSagaAction('COMPANY_CREATE_CONTACT'),
  COMPANY_UPDATE_CONTACT: createSagaAction('COMPANY_UPDATE_CONTACT'),
  COMPANY_DELETE_CONTACT: createSagaAction('COMPANY_DELETE_CONTACT'),
  // notes
  GET_CONTACT_NOTE: createSagaAction('GET_CONTACT_NOTE'),
  CREATE_CONTACT_NOTE: createSagaAction('CREATE_CONTACT_NOTE'),
  EDIT_CONTACT_NOTE: createSagaAction('EDIT_CONTACT_NOTE'),
  DELETE_CONTACT_NOTE: createSagaAction('DELETE_CONTACT_NOTE'),
  // jobs
  GET_CONTACT_JOB: createSagaAction('GET_CONTACT_JOB'),
  // leads
  GET_CONTACT_LEAD: createSagaAction('GET_CONTACT_LEAD'),

  COMPANY_CREATE_CONTACT_BY_ID: createSagaAction('COMPANY_CREATE_CONTACT_BY_ID'),

  FETCH_CONTACT_GROUPS_BY_JOB_ID: createSagaAction('FETCH_CONTACT_GROUPS_BY_JOB_ID'),
  UPDATE_COMPANY_PRIMARY_CONTACT: createSagaAction('UPDATE_COMPANY_PRIMARY_CONTACT')
}

// Action Creators
export const actions = {
  getAllContacts: () => ({
    type: constants.GET_ALL_CONTACTS.ACTION
  }),
  getContactList: () => ({
    type: constants.GET_CONTACT_LIST.ACTION
  }),
  createContactIndividual: ({ content, userId }) => ({
    type: constants.CREATE_CONTACT_INDIVIDUAL.ACTION,
    content,
    userId
  }),
  editContactIndividual: ({ content, userId, contactId }) => ({
    type: constants.EDIT_CONTACT_INDIVIDUAL.ACTION,
    content,
    userId,
    contactId
  }),
  deleteContactIndividual: ({ contactId }) => ({
    type: constants.DELETE_CONTACT_INDIVIDUAL.ACTION,
    contactId
  }),
  addEmail: ({ contactId, address, emailType }) => ({
    type: constants.ADD_EMAIL.ACTION,
    contactId,
    address,
    emailType
  }),
  editEmail: ({ emailId, contactId, address, emailType }) => ({
    type: constants.EDIT_EMAIL.ACTION,
    emailId,
    contactId,
    address,
    emailType
  }),
  deleteEmail: ({ emailId, contactId }) => ({
    type: constants.DELETE_EMAIL.ACTION,
    emailId,
    contactId
  }),
  getContactEmails: ({ contactId }) => ({
    type: constants.GET_EMAILS.ACTION,
    contactId
  }),
  addPhone: ({ contactId, number, phoneType }) => ({
    type: constants.ADD_PHONE.ACTION,
    contactId,
    number,
    phoneType
  }),
  editPhone: ({ phoneId, contactId, number, phoneType }) => ({
    type: constants.EDIT_PHONE.ACTION,
    phoneId,
    contactId,
    number,
    phoneType
  }),
  deletePhone: ({ phoneId, contactId }) => ({
    type: constants.DELETE_PHONE.ACTION,
    phoneId,
    contactId
  }),
  getContactPhones: ({ contactId }) => ({
    type: constants.GET_PHONES.ACTION,
    contactId
  }),
  getCompanyContacts: ({ companyId }) => ({
    type: constants.GET_COMPANY_CONTACTS.ACTION,
    companyId
  }),
  companyCreateContact: ({ contact, companyId, userId }) => ({
    type: constants.COMPANY_CREATE_CONTACT.ACTION,
    contact,
    companyId,
    userId
  }),
  companyCreateContactById: ({ contactId, companyId, userId }) => ({
    type: constants.COMPANY_CREATE_CONTACT_BY_ID.ACTION,
    contactId,
    companyId,
    userId
  }),
  companyUpdateContact: ({ contactId, contact, companyId, userId }) => ({
    type: constants.COMPANY_UPDATE_CONTACT.ACTION,
    contactId,
    contact,
    companyId,
    userId
  }),
  deleteCompanyContacts: ({ contactId, companyId }) => ({
    type: constants.COMPANY_DELETE_CONTACT.ACTION,
    contactId,
    companyId
  }),
  // notes
  getContactNote: ({ contactId }) => ({
    type: constants.GET_CONTACT_NOTE.ACTION,
    contactId
  }),
  createContactNote: ({ content, userId, contactId }) => ({
    type: constants.CREATE_CONTACT_NOTE.ACTION,
    content,
    userId,
    contactId
  }),
  editContactNote: ({ content, noteId, contactId }) => ({
    type: constants.EDIT_CONTACT_NOTE.ACTION,
    content,
    noteId,
    contactId
  }),
  deleteContactNote: ({ noteId, contactId }) => ({
    type: constants.DELETE_CONTACT_NOTE.ACTION,
    noteId,
    contactId
  }),
  // jobs
  getContactJobs: ({ contactId }) => ({
    type: constants.GET_CONTACT_JOB.ACTION,
    contactId
  }),
  // leads
  getContactLeads: ({ contactId }) => ({
    type: constants.GET_CONTACT_LEAD.ACTION,
    contactId
  }),
  fetchContactGroupsByJobId: ({ jobId }) => ({
    type: constants.FETCH_CONTACT_GROUPS_BY_JOB_ID.ACTION,
    jobId
  }),
  updateCompanyPrimaryContact: ({ contactId, companyId }) => ({
    type: constants.UPDATE_COMPANY_PRIMARY_CONTACT.ACTION,
    contactId,
    companyId
  })
}

// Reducer
const initialState = [
  {
    name: ''
  }
]

export default createReducer(initialState, (state, { type, payload }) => {
  switch (type) {
    default:
      return state
    case constants.GET_CONTACT_LIST.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_CONTACT_LIST.SUCCESS:
      return {
        ...state,
        contacts: payload,
        loading: false
      }
    case constants.GET_ALL_CONTACTS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_ALL_CONTACTS.SUCCESS:
      return {
        ...state,
        allContacts: payload,
        loading: false
      }
    case constants.CREATE_CONTACT_INDIVIDUAL.SUCCESS:
      return { ...state, payload }
    case constants.EDIT_CONTACT_INDIVIDUAL.SUCCESS:
      return { ...state, payload }
    case constants.DELETE_CONTACT_INDIVIDUAL.SUCCESS:
      return {
        ...state
      }
    case constants.ADD_EMAIL.ACTION:
      return { ...state, error: null, addingEmail: true }
    case constants.ADD_EMAIL.SUCCESS:
      return {
        ...state,
        addingEmail: false
      }
    case constants.EDIT_EMAIL.ACTION:
      return { ...state, error: null, editingEmail: true }
    case constants.EDIT_EMAIL.SUCCESS:
      return {
        ...state,
        editingEmail: false
      }
    case constants.DELETE_EMAIL.ACTION:
      return { ...state, error: null, deletingEmail: true }
    case constants.DELETE_EMAIL.SUCCESS:
      return {
        ...state,
        deletingEmail: false
      }
    case constants.GET_EMAILS.ACTION:
      return { ...state, error: null, loadingGetEmails: true }
    case constants.GET_EMAILS.SUCCESS:
      return {
        ...state,
        emails: payload
      }
    case constants.ADD_PHONE.ACTION:
      return { ...state, error: null, addingPhone: true }
    case constants.ADD_PHONE.SUCCESS:
      return {
        ...state,
        addingPhone: false
      }
    case constants.EDIT_PHONE.ACTION:
      return { ...state, error: null, editingPhone: true }
    case constants.EDIT_PHONE.SUCCESS:
      return {
        ...state,
        editingPhone: false
      }
    case constants.DELETE_PHONE.ACTION:
      return { ...state, error: null, deletingPhone: true }
    case constants.DELETE_PHONE.SUCCESS:
      return {
        ...state,
        deletingPhone: false
      }
    case constants.GET_PHONES.ACTION:
      return { ...state, error: null, loadingGetPhones: true }
    case constants.GET_PHONES.SUCCESS:
      return {
        ...state,
        phones: payload
      }
    case constants.GET_COMPANY_CONTACTS.SUCCESS:
      return { ...state, companyContacts: payload }
    case constants.COMPANY_CREATE_CONTACT.SUCCESS:
      return { ...state }
    case constants.COMPANY_CREATE_CONTACT_BY_ID.SUCCESS:
      return { ...state }
    case constants.COMPANY_UPDATE_CONTACT.SUCCESS:
      return { ...state }
    case constants.COMPANY_DELETE_CONTACT.SUCCESS:
      return { ...state }
    // NOTES
    case constants.GET_CONTACT_NOTE.SUCCESS:
      return { ...state, contactsNotes: payload }

    case constants.CREATE_CONTACT_NOTE.ACTION:
      return { ...state }
    case constants.CREATE_CONTACT_NOTE.SUCCESS:
      return {
        ...state
      }
    case constants.EDIT_CONTACT_NOTE.ACTION:
      return { ...state }
    case constants.EDIT_CONTACT_NOTE.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_CONTACT_NOTE.ACTION:
      return { ...state }
    case constants.DELETE_CONTACT_NOTE.SUCCESS:
      return {
        ...state
      }
    // JOBS
    case constants.GET_CONTACT_JOB.SUCCESS:
      return { ...state, contactJobs: payload }
    // LEADS
    case constants.GET_CONTACT_LEAD.SUCCESS:
      return { ...state, contactLeads: payload }

    case constants.FETCH_CONTACT_GROUPS_BY_JOB_ID.ACTION:
      return { ...state, error: null, loading: true }
    case constants.FETCH_CONTACT_GROUPS_BY_JOB_ID.SUCCESS:
      return {
        ...state,
        contactGroups: payload
      }
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/contactsActions.js